export interface StoryPreferences {
  id?: string;
  story_id: string;
  user_id: string;
  
  // Story Foundation
  plot_focus: number; // 1-5
  character_focus: number; // 1-5
  worldbuilding_depth: number; // 1-5
  theme_focus: number; // 1-5
  
  // Writing Style
  tone: number; // 1-5
  pacing: number; // 1-5
  
  created_at?: string;
  updated_at?: string;
}

export const PREFERENCE_DESCRIPTIONS = {
  plot_focus: {
    1: "Story is about character discovery, relationships, personal growth. Plot is minimal.",
    2: "Mix of character moments and plot developments.",
    3: "Balanced - roughly equal plot and character focus.",
    4: "Plot-driven with strong character reactions to events.",
    5: "Action-packed with major plot twists and events in every chapter."
  },
  character_focus: {
    1: "Archetypal characters serving the story. Simple, clear roles.",
    2: "Mix of archetypal and unique characters.",
    3: "Balanced - some complexity and depth in characters.",
    4: "Complex, multi-dimensional cast with deep personalities.",
    5: "Every character has contradictions, hidden depths, and evolving arcs."
  },
  worldbuilding_depth: {
    1: "Just what's needed for the story. Minimal locations, simple rules.",
    2: "Basic worldbuilding with some depth.",
    3: "Balanced - moderate detail and lore.",
    4: "Extensive worldbuilding with multiple locations and systems.",
    5: "Rich, intricate lore with detailed history, cultures, and interconnected systems."
  },
  theme_focus: {
    1: "Pure entertainment, minimal deeper meaning or philosophy.",
    2: "Some thematic elements woven throughout.",
    3: "Balanced - story has meaning but doesn't hammer it.",
    4: "Clear thematic exploration with meaningful questions.",
    5: "Deep philosophical exploration that defines the story."
  },
  tone: {
    1: "Light, hopeful, humorous. Characters overcome obstacles with optimism.",
    2: "Mostly light with occasional darker moments.",
    3: "Balanced mix of light and dark moments.",
    4: "Mostly dark and serious with rare humor.",
    5: "Dark, gritty, cynical. Consequences matter. Humor is dark or absent."
  },
  pacing: {
    1: "Slow burn. Deliberate, introspective. Lots of reflection and internal life.",
    2: "Leisurely pace with character moments and plot progression.",
    3: "Moderate, balanced pacing. Steady story progression.",
    4: "Quick scenes with lots of happening. Quick chapter transitions.",
    5: "Fast-paced, frenetic. Cliffhangers, constant tension, quick cuts."
  }
};

export const DEFAULT_PREFERENCES: Omit<StoryPreferences, 'id' | 'story_id' | 'user_id' | 'created_at' | 'updated_at'> = {
  plot_focus: 3,
  character_focus: 3,
  worldbuilding_depth: 3,
  theme_focus: 3,
  tone: 3,
  pacing: 3
};

/**
 * Simplified preferences for extraction and generation (without DB fields)
 */
export interface ExtractionPreferences {
  plot_focus: number;
  character_focus: number;
  worldbuilding_depth: number;
  theme_focus: number;
  tone: number;
  pacing: number;
}